module.exports = __webpack_public_path__ + "img/trackd-icon-white-filled.b4c9d1c8.svg";